import { render, staticRenderFns } from "./Userchart.vue?vue&type=template&id=68d43b70&"
import script from "./Userchart.vue?vue&type=script&lang=js&"
export * from "./Userchart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports